import Choices from "choices.js";
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Global {

    constructor() {
        this.initChoices();
        this.initReviews();
        this.initUsps();
        this.handleForm();
        setTimeout(() => {
            this.transitionAfterPageLoad();
        }, 300);

        if (document.querySelector('nav').classList.contains('nav-dark')) {
            document.querySelector('.logo img').src = '/img/svgs/logo-kleur.svg';
        }
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    handleForm() {
        if (document.querySelector('.form-style')) {
            const formGroups = document.querySelectorAll('.form-style .form-group');

            formGroups.forEach((item) => {
                const input = item.querySelector('input, textarea');

                const handleFocus = () => {
                    item.classList.add('focus');
                }

                const handleBlur = () => {
                    if (input.value.length === 0) {
                        item.classList.remove('focus');
                    }
                }

                const handleInput = () => {
                    if (input.value.length === 0 && document.activeElement === input) {
                        item.classList.add('focus');
                    } else if (input.value.length > 0) {
                        item.classList.add('focus');
                    } else {
                        item.classList.remove('focus');
                    }
                }

                input.addEventListener('focus', handleFocus);
                input.addEventListener('blur', handleBlur);
                input.addEventListener('input', handleInput);

                if (input.value.length > 0) {
                    item.classList.add('focus');
                }
            });
        }
    }


    transitionAfterPageLoad(){
        document.querySelector("body").classList.remove("no-transition");
    }

    initUsps(){
        if(document.querySelector('#usps') !== null){
            new Swiper('#usps .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1000: {
                        slidesPerView: 3,
                    }
                }
            });
        }
    }

    initReviews(){
        if(document.querySelector('#reviews') !== null){
            new Swiper('#reviews .swiper-container', {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }
    }
}
